import React from "react";

export default function Credits() {
  return (
    <div className="min-h-screen flex items-center justify-center flex-col lg:min-w-full">
      <a href="https://storyset.com/social-media">
        Social media illustrations by Storyset
      </a>
      <a href="https://storyset.com/work">Work illustrations by Storyset</a>
      <p>Artisan picture by cottonbro studio in the website pexels.com</p>
    </div>
  );
}
